import React, { FC, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Loading } from "../components/Loading";
import InputParameters from "../components/InputParameters";
import Driver from "../components/Driver";
import { NextButton } from "../components/NextButton";
import { withRouter, RouteComponentProps } from "../utils/useRouter";
import { store } from "../store";
import { makeStyles, Box, Typography } from "@material-ui/core";
import { useIdentityContext } from "react-netlify-identity";
import { Text } from "../components/Text";

export interface ParameterState {
  horizontalBeamwidth: number | null;
  verticalBeamwidth: number | null;
  horizontalMax: number | null;
  verticalMax: number | null;
  upperFrequency: number | null;
}

const Parameters: FC<RouteComponentProps> = observer(({ history }) => {
  const classes = styles();
  const [step, setStep] = useState<number>(0);
  const {
    appLoading,
    setLoading,
    calculateHornDesign,
    setUser,
    missingRequiredParams,
    resetState,
  } = store;
  const { user } = useIdentityContext();
  const calculate = async () => {
    setLoading(true);
    const tokenExpires = user?.tokenDetails().expires_at;
    if (user && tokenExpires < new Date().getTime()) {
      await user?.jwt(true);
    }
    setUser(user);
    await calculateHornDesign();
    history.push("/results");
    setLoading(false);
  };

  const handleStepChange = () => {
    if (step === 1) {
      return calculate();
    }
    setStep(step + 1);
  };

  useEffect(() => {
    if (step === 0) {
      resetState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  if (appLoading) return <Loading text="Calculating..." />;

  return (
    <Box className={classes.container}>
      <Box className={classes.box}>
        {step === 0 && (
          <Box maxWidth={600} width={1}>
            <InputParameters />
            <Text>All fields marked * must be completed</Text>
          </Box>
        )}
        {step === 1 && (
          <Box>
            <Typography gutterBottom>
              Choose a Compression Driver – The results shown will be what is
              achievable with the specified driver on your horn design.
            </Typography>
            <Driver />
          </Box>
        )}
        {step < 2 && (
          <Box className={classes.next}>
            <NextButton
              disabled={missingRequiredParams}
              onClick={handleStepChange}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
});

const styles = makeStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100%",
  },
  box: {
    flex: 1,
    padding: "0 20px",
    position: "relative",
    overflow: "auto",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  next: {
    maxWidth: 600,
    width: "100%",
    background: "white",
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 10,
    marginBottom: 10,
  },
  loaderContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 50,
  },
  loader: {
    marginTop: 20,
  },
}));
export default withRouter(Parameters);
